import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './auth';
import { BaSeRoot } from '@base/react';
import { AppProvider, useApp } from './context/app';
import { FiltersProvider } from './context/filters';
import { Global } from '@emotion/react';
import { globalStyles } from './newLayout/styles/global';
import { QueryClient, QueryClientProvider } from 'react-query';
import { MaintenanceProvider } from "./context/maintenance";
import './vendor.css';
import './style.scss';


const RenderRouter = () => {
  const { newLayout } = useApp();
  const [key, setKey] = React.useState(0);

  React.useEffect(() => {
    setKey(prev => prev + 1);
  }, [newLayout]);

  const LazyRouter = React.useMemo(
    () =>
      React.lazy(() =>
        newLayout
          ? import('./newLayout/routes')
          : import('./routes')
      ),
    [newLayout]
  );

  return (
    <React.Suspense fallback={null} key={key}>
      <LazyRouter />
    </React.Suspense>
  );
};


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      staleTime: 1000 * 60 * 5
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BaSeRoot>
        <AuthProvider>
          <AppProvider>
            <MaintenanceProvider>
              <FiltersProvider>
                <RenderRouter />
                <Global styles={globalStyles} />
              </FiltersProvider>
            </MaintenanceProvider>
          </AppProvider>
        </AuthProvider>
      </BaSeRoot>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
  () => {
    window.__APP_READY__ = true;
  }
);

serviceWorker.register();
